import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../../Input";
import { Button } from "../../Button";
import language from "../../../language";
import axios from "axios";
import toastMessage from "../../../utils/toastMessage";
import { getStorage } from "../../../utils/storage";
import availableOptions from "../../../constants/availableOptions";
import {
  generateRandomNumber,
  generateRandomString,
} from "../../../utils/random";
import hospitalQuery from "../../../utils/queries/hospitalQuery";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class BulkRequest extends React.Component {
  state = {
    error: {},
    isSubmitting: false,
    donors: [],
    distributors: [],
    hospitals: [],
    numberOfPackages: "",
    isActive: availableOptions[0],
    description: "",
    approvals: [],
    packages: [],
    centers: [],
    centerSites: [],
    bloodBanks: [],
    requestNo: "",
    transfusionSets: "",
    allowedBloodBanks: [],
    selectedBloodBank: null,
    isFetchingHospital: false,
  };

  componentDidMount = async () => {
    this.setState({
      requestNo:
        generateRandomString(4).toUpperCase() +
        "-" +
        generateRandomNumber(0, 1000000),
    });

    await this.setState({ ...this.props });

    if (!this.props._id) {
      await this.fetchAllowedBloodBanks();
    }

    if (this.props._id) {
      this.setState({
        transfusionSets: this.props.transfusionSets,
        bloodBank:
          this.props.bloodBank && this.props.bloodBank._id
            ? {
                label: this.props.bloodBank?.center?.name,
                value: this.props.bloodBank._id,
              }
            : null,
        distributor:
          this.props.distributor && this.props.distributor._id
            ? {
                label: this.props.distributor.name,
                value: this.props.distributor._id,
              }
            : null,
        hospital:
          this.props.hospital && this.props.hospital._id
            ? {
                label: this.props.hospital.name,
                value: this.props.hospital._id,
              }
            : null,
        packages: this.props.packages || [],
        approvals: this.props.approvals || [],
        isActive: {
          label: this.props.isActive + "",
          value: this.props.isActive + "",
        },
      });
    }
  };

  fetchAllowedBloodBanks = async () => {
    let user = await getStorage();
    this.setState({ isFetchingHospital: true });
    const hospitalRes = await hospitalQuery(this.props.defaultLanguage, {
      id: user.hospital?._id || user.hospital,
    });
    this.setState({ isFetchingHospital: false });
    const hospitalInfo = Array.isArray(hospitalRes)
      ? hospitalRes
      : hospitalRes?.data || [];
    if (hospitalInfo?.length > 0) {
      const { multipleAllowedBloodBank } = hospitalInfo[0];
      if (multipleAllowedBloodBank && multipleAllowedBloodBank.length > 1) {
        this.setState({
          allowedBloodBanks: multipleAllowedBloodBank.map((bb) => ({
            label: bb.name,
            value: bb._id,
          })),
        });
      }
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });
  };

  onSavePackages(packages) {
    this.setState({
      packages,
    });
  }

  validateForm() {
    let { error, requestNo, transfusionSets, allowedBloodBanks, selectedBloodBank } = this.state;

    if (requestNo === "") {
      error.requestNo =
        language[this.props.defaultLanguage].request_number_required;
    }

    if (transfusionSets === "") {
      error.transfusionSets =
        language[this.props.defaultLanguage].transfusion_sets_required;
    }

    if (allowedBloodBanks.length > 1 && !selectedBloodBank) {
      error.selectedBloodBank =
        language[this.props.defaultLanguage].blood_bank_required ||
        "Please select a blood bank to request from";
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let user = await getStorage();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isSubmitting: true });

      const hospitalRes = await hospitalQuery(this.props.defaultLanguage, {
        id: user.hospital?._id || user.hospital,
      });

      const hospitalInfo = Array.isArray(hospitalRes)
        ? hospitalRes
        : hospitalRes?.data || [];

      if (!hospitalInfo || hospitalInfo?.length === 0) {
        this.setState({ isSubmitting: false });
        return toastMessage("error", "Missing hospital information");
      }

      if (!hospitalInfo?.[0]?.allowedBloodBank) {
        this.setState({ isSubmitting: false });
        return toastMessage(
          "error",
          "There is no allowed blood bank to request from setup, please consult your administrator"
        );
      }

      let { _id, transfusionSets, requestNo, selectedBloodBank } = this.state,
        url = `${API_URL}/bloodrequest`,
        method = "POST";

      let requestedBody = {
        requestNo,
        hospital: user.hospital?._id || user.hospital,
        bloodBank:
          selectedBloodBank?.value ||
          hospitalInfo[0].allowedBloodBank?._id ||
          hospitalInfo[0].allowedBloodBank,
        account: user.id,
        type: "bulk",
        transfusionSets,
      };

      if (_id && _id !== "") {
        method = "PUT";
        requestedBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        data: requestedBody,
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              method === "PUT" ? "update_data_success" : "add_data_success"
            ]
          );

          this.props.getData && this.props.getData(true);
          this.props.handleCloseModal && this.props.handleCloseModal();

          this.onReset();

          window.location.href = `/dashboard/request/bulk/${requestNo}`;
        })
        .catch((error) => {
          toastMessage("error", error);
          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  onReset() {
    this.setState({
      isSubmitting: false,
      requestNo:
        generateRandomString(4).toUpperCase() +
        "-" +
        generateRandomNumber(0, 1000000),
      transfusionSets: "",
    });
  }

  render() {
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage]
                    .request_number_placeholder
                }
                label={language[this.props.defaultLanguage].request_number}
                required
                value={this.state.requestNo}
                onChange={(e) => this.onChangeText("requestNo", e)}
                error={this.state.error.requestNo}
                disabled
              />
            </div>
            <div className="col-md-12">
              <Input
                label={language[this.props.defaultLanguage].transfusion_sets}
                required
                value={this.state.transfusionSets}
                onChange={(e) => this.onChangeText("transfusionSets", e)}
                error={this.state.error.transfusionSets}
                type="number"
              />
            </div>
            {this.state.allowedBloodBanks.length > 1 && (
              <div className="col-md-12">
                <Select
                  options={this.state.allowedBloodBanks}
                  placeholder={language[this.props.defaultLanguage].select}
                  label={
                    language[this.props.defaultLanguage].to || "To"
                  }
                  required
                  value={this.state.selectedBloodBank}
                  onChange={(e) => this.onChangeText("selectedBloodBank", e)}
                  error={this.state.error.selectedBloodBank}
                  isLoading={this.state.isFetchingHospital}
                />
              </div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={"Next"}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BulkRequest);
